export default "__VITE_ASSET__DbdkYOkZ__"